export default "__VITE_ASSET__a1MqK9Us__"